import { useEffect } from 'react';
import { useIsAuthenticated } from '@/common/stores/authStore';
import {
  requestPushNotificationPermission,
  subscribeToPushNotifications,
} from '@/lib/pwa';
import { savePushSubscription } from '../api/notifications.api';

const VAPID_PUBLIC_KEY = import.meta.env.VITE_VAPID_PUBLIC_KEY as string | undefined;

export function usePushSubscription() {
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (!isAuthenticated || !VAPID_PUBLIC_KEY) return;
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;

    void (async () => {
      const granted = await requestPushNotificationPermission();
      if (!granted) return;

      const subscription = await subscribeToPushNotifications(VAPID_PUBLIC_KEY);
      if (!subscription) return;

      const json = subscription.toJSON();
      if (!json.endpoint || !json.keys?.p256dh || !json.keys?.auth) return;

      try {
        await savePushSubscription({
          endpoint: json.endpoint,
          keys: { p256dh: json.keys.p256dh, auth: json.keys.auth },
        });
      } catch {
        // Non-critical — push will degrade gracefully
      }
    })();
  }, [isAuthenticated]);
}
